import Vue from 'vue'
import router from '@/router'
import { logout, setPassword, usernameLogin } from '@/api'
import { storeObject, getObject, removeObject } from '@/helpers/storage'
import { Role } from '@/constants'
import moment from 'moment'

export default {
    namespaced: true,
    state: {
        user: getObject('session') ? getObject('session') : {},
        isLoading: false
    },
    mutations: {
        SET_USER: (state, user) => state.user = user,
        SET_LOADING: state => state.isLoading = !state.isLoading,
        REFRESH_TOKEN: (state, token) => state.user.token = token
    },
    actions: {
        /**
         *
         * @param {function} commit
         * @param {function} dispatch
         * @param {object} user
         */
        login({ commit, dispatch }, user) {
            commit('SET_LOADING');
            usernameLogin(user).then(res => {
                dispatch('configure', res);
                router.push({ name: 'announcements' })
            })
            .finally(() => commit('SET_LOADING'))
        },

        /**
         *
         * @param {function} dispatch
         * @param {object} state
         */
        logout({ dispatch, state }) {
            logout(state.user.token).then(() => dispatch('vanish'))
        },

        /**
         *
         * @param {function} commit
         */
        vanish({ commit }) {
            commit('SET_USER', {});
            removeObject('session');
            removeObject(process.env.VUE_APP_USER_TOKEN_NAME);
            removeObject(process.env.VUE_APP_USER_TOKEN_EXPIRATION_DATE);
            router.push({ name: 'login' })
                .catch(err => {
                    location.reload()
                })
        },

        /**
         *
         * @param {function} dispatch
         * @param {AxiosResponse} res
         */
        refreshToken({ dispatch }, res) {
            dispatch('configure', res)
        },

        /**
         *
         * @param {object} lang
         * @param {{ email: string }} user
         * @param {string} token
         */
        setPassword({ rootGetters: { lang } }, { user, token }) {
            setPassword(user, token).then(res => {
                Vue.prototype.$message.success(lang.messages.responses.password_created);
                router.push({ name: 'listWatches', query: { page: 1 } })
            })
        },

        /**
         *
         * @param {function} commit
         * @param {AxiosResponse} response
         * @description this action is the one delegated
         * to configure the session for login or logout
         */
        configure({ commit }, response) {
            commit('SET_USER', response.data.user);
            let token = response.data.token;
            let expiration = new Date(response.data.expire_at);
            storeObject('session', response.data.user);
            localStorage.setItem(process.env.VUE_APP_USER_TOKEN_NAME, token)
            localStorage.setItem(process.env.VUE_APP_USER_TOKEN_EXPIRATION_DATE, moment(expiration).format('YYYY-MM-DD HH:mm'))
            //commit('SET_LOADING');
            // axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            // location.reload();
        }
    },

    getters: {
        /**
         *
         * @param {object} user
         * @returns {*|boolean}
         * @description user is destructured from the state as is the first parameter.
         */
        isLogged: ({ user }) => localStorage.getItem(process.env.VUE_APP_USER_TOKEN_NAME) && Object.keys(user).length > 0,

        /**
         *
         * @param {object} user
         * @param {boolean} isLogged
         * @returns {*|boolean}
         */
        loggedUserIsAdmin: ({ user }, { isLogged }) => isLogged && parseInt(user.type) === Role.admin,

        /**
         *
         * @param {object} user
         * @param {boolean} isLogged
         * @returns {*|boolean}
         */
        loggedUserIsMerchant: ({ user }, { isLogged }) => isLogged && parseInt(user.type) === Role.merchant
    }
}
